import Detail1 from 'images/games/bingo-tour/detail1.png'
import Detail2 from 'images/games/bingo-tour/detail2.png'
import Detail3 from 'images/games/bingo-tour/detail3.png'
import Footer from 'images/games/bingo-tour/footer.png'
import Icon from 'images/games/bingo-tour/icon.png'
import Swiper1 from 'images/games/bingo-tour/swiper1.webp'
import Swiper2 from 'images/games/bingo-tour/swiper2.webp'
import Swiper3 from 'images/games/bingo-tour/swiper3.webp'
import Swiper4 from 'images/games/bingo-tour/swiper4.webp'
import Swiper5 from 'images/games/bingo-tour/swiper5.webp'
import Swiper6 from 'images/games/bingo-tour/swiper6.webp'
import Swiper7 from 'images/games/bingo-tour/swiper7.webp'
import { GamesLink } from '../../components'
import { BingoTourEntity } from './entity'
import { TemplatePageProps } from './types'

export const BingoTourDetail: TemplatePageProps = {
  entity: {
    ...BingoTourEntity,
    logo: Icon,
    title: (
      <>
        <strong>Bingo Tour</strong>: Online Bingo with a Twist!
      </>
    ),
    description: (
      <>
        Get ready for a fresh take on a timeless favorite with Bingo Tour! Play quick{' '}
        <strong>bingo games online</strong> and compete for real cash prizes. With exciting power-ups and seasonal
        events, the fun never stops! Download now from the Apple Store, Galaxy Store, and APK. Begin your bingo
        adventure now!
      </>
    ),
  },
  media: {
    facebook: 'https://www.facebook.com/BingoTourAvia/',
    instagram: 'https://www.instagram.com/bingotourofficial/',
  },
  swiper: [
    { image: Swiper1 },
    { image: Swiper2 },
    { image: Swiper3 },
    { image: Swiper4 },
    { image: Swiper5 },
    { image: Swiper6 },
    { image: Swiper7 },
  ],
  content: [
    {
      title: 'How to Win Bingo Tour: Gameplay and Strategy',
      description: (
        <>
          Bingo Tour delivers a fast-paced twist on the <strong>classic bingo</strong> game. Quickly daub matching
          numbers as balls are called, completing rows, columns, diagonals, and corners to score Bingos. Clear the
          entire card for bonus points! Speed and accuracy boost your score, and top players win real cash prizes. Fill
          the meter by daubing quickly, then activate power-ups like Daub It, Gimme More, or Earn Double to score big.
          With quick rounds, exciting features, and adorable animal companions, Bingo Tour is anything but ordinary!
        </>
      ),
      image: Detail1,
    },
    {
      title: 'Bingo Adventure for Real Rewards',
      description: (
        <>
          Bingo Tour is an <strong>online bingo</strong> app that offers a competitive, skill-based twist and real cash
          prizes! Compete in multiplayer tournaments against players from diverse locations, all matched based on equal
          skill levels for a fair and exciting challenge. Choose your match mode, from free games to cash tournaments,
          and level up your skills as you play. Explore fun and rewarding events like Passport Puzzler, Plinko Drop, and
          Net Fishing, offering opportunities to earn Bonus Cash (in-game use only) and Gems to unlock more matches.
          Dive into the ultimate competitive bingo adventure in Bingo Tour!
        </>
      ),
      image: Detail2,
    },
    {
      title: 'Trusted Bingo with Trusted Payment Partners',
      description: (
        <>
          Bingo Tour offers a secure and hassle-free experience with trusted payment partners for both deposits and
          withdrawals. Withdraw your winnings quickly and safely through PayPal, ensuring peace of mind with every
          transaction. For deposits, you have a variety of secure options to choose from, including PayPal, Venmo, Apple
          Pay, Visa, Mastercard, Amex, and Discover. With these reliable methods, you can easily fund your account and
          start to <strong>play bingo online</strong>. Play with confidence, knowing your money is in safe hands,
          whether you&#39;re depositing or cashing out.
        </>
      ),
      image: Detail3,
    },
    {
      title: 'Explore Games Beyond Bingo Tour',
      description: (
        <>
          If you enjoy the adventure and competition Bingo Tour brings, more action awaits with Avia’s wide variety of{' '}
          <GamesLink strong>fun games</GamesLink> designed to match every interest and skill level. Try more bingo fun
          with Bingo Clash and Bingo Bliss, or explore other categories like card games in Solitaire Clash, pool
          challenges in 8 Ball Strike, bubble popping in Bubble Buzz, and strategic block stacking in Blockolot.
          Discover our full collection and explore the best games suited to your preferences and skills!
        </>
      ),
    },
  ],
  footer: {
    image: Footer,
  },
}
